/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Api } from '../../../api';
import {
  errorToast,
  successToast,
  useOutsideClick,
  getFilterKey,
  isSuperAdmin
} from '../../../utils/helper';
import Breadcrumb from '../../../component/common/Breadcrumb';
import Table from '../../../component/common/Table';
import Pagination from '../../../component/common/Pagination/Pagination';
import { Helmet } from 'react-helmet';
import SearchInput from '../../../component/common/Input/SearchInput';
import { APPROVAL_STATUS_DROPDOWN, PER_PAGE, STATUS_FOR_DROPDOWN } from '../../../utils/constants';
import { Fragment } from 'react';
import { FunnelIcon } from '@heroicons/react/24/outline';
import { Transition } from '@headlessui/react';
import SelectMenu from '../../../component/common/SelectMenu';
import { XMarkIcon } from '@heroicons/react/20/solid';
import PropTypes from 'prop-types';
import Loader from '../../../component/common/Loader';
import Topbar from '../../PulseSurvey/Topbar';
import { StatCard, STAT_ICONS, FilterPanel, TableCard} from '../../../component/common/designSystem';
import { healthVideosPageData as pageData } from '../../../utils/pageContent';

const pages = [{ name: pageData.pageTitle, href: '/guidance' }];

const PAGE_SIZE = 10;

const draft_check = {
  name: 'Draft',
  value: 0
};

const Guidance = (props) => {
  const navigate = useNavigate();
  const wrapperRef = useRef(null);
  const [loader, setLoader] = useState(true);
  const [guidanceList, setGuidanceList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [adminNameList, setAdminNameList] = useState([]);
  const [sortOrder, setSortOrder] = useState(-1);
  const [sortBy, setSortBy] = useState('');
  const [selectedPerPage, setSelectedPerPage] = useState(PER_PAGE[0]);
  const [guidanceArray, setGuidanceArray] = useState(null);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterQuery, setFilterQuery] = useState('');
  const [categoriesList, setCategoriesList] = useState([]);
  const [filterCriteria, setFilterCriteria] = useState({
    guidanceType: '',
    healthVideoStatus: '',
    approvalStatus: '',
    ratings: '',
    categoryId: ''
  });
  const [isDraftsOpen, setIsDraftsOpen] = useState(false);
  const userData = JSON.parse(localStorage.getItem('userData'));
  const handlePagination = (pageNumber, pageSize, searchKey, sortBy, sortOrder) => {
    handleFilterAdminList();
    setLoader(true);

    if (isDraftsOpen) {
      Api.getExpertGuidancesList(
        pageNumber,
        pageSize,
        searchKey,
        sortBy,
        sortOrder,
        '',
        true,
        userData?.id
      ).then((response) => {
        if (response?.data?.meta?.code === 1) {
          setCurrentPage(pageNumber);
          setGuidanceList(response?.data?.data);
          setTotalCount(response?.data?.meta?.totalRecords);
          setLoader(false);
        } else if (response?.data?.meta?.code === 0) {
          setCurrentPage(1);
          setGuidanceList([]);
          setTotalCount(0);
          setLoader(false);
          errorToast(response?.data?.meta?.message);
        } else {
          setLoader(false);
        }
      });
      return;
    }
    Api.getGuidancesList(pageNumber, pageSize, searchKey, sortBy, sortOrder).then((response) => {
      if (response?.data?.meta?.code === 1) {
        setCurrentPage(pageNumber);
        setGuidanceList(response?.data?.data);
        setTotalCount(response?.data?.meta?.totalRecords);
        setLoader(false);
      } else if (response?.data?.meta?.code === 0) {
        setCurrentPage(1);
        setGuidanceList([]);
        setTotalCount(0);
        setLoader(false);
        errorToast(response?.data?.meta?.message);
      } else {
        setLoader(false);
      }
    });
  };

  const guidanceData = () => {
    setLoader(true);
    Api.getGuidanceData()
      .then((response) => {
        if (response?.data?.meta?.code === 200) {
          const res = response?.data?.data;

          setGuidanceArray(res);
        } else {
          setGuidanceArray([]);
          setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
      });
  };

  useEffect(() => {
    guidanceData();

    Api.getCategoriesById(19).then((res) => {
      const categories = res?.data?.data?.map((item) => ({
        ...item,
        name: item?.name,
        value: item?._id
      }));

      setCategoriesList([{ name: 'Select Category', value: '' }, ...(categories || [])]);
    });
  }, []);

  const cardList = [
    <StatCard
      icon={STAT_ICONS.onlineNow}
      title={pageData.liveVideosLabel}
      value={guidanceArray?.liveGuidances ?? 0}
    />,
    <StatCard
      icon={STAT_ICONS.plays}
      title={pageData.videoWatchContLabel}
      value={
        <>
          {guidanceArray?.videoWatchCount ?? 0}{' '}
          <span className="text-[14px]">{pageData.timesLabel}</span>
        </>
      }
    />,
    <StatCard
      icon={STAT_ICONS.rating}
      title={pageData.mostPopularTopicLabel}
      value={guidanceArray?.mostPopular ?? '-'}
    />,
    <StatCard
      icon={STAT_ICONS.sessions}
      title={pageData.leastUsedTopicLabel}
      value={guidanceArray?.leastUsed ?? '-'}
    />
  ];

  useEffect(() => {
    if (searchTerm) {
      let searchParam = searchTerm.trim();
      const delayDebounceFn = setTimeout(() => {
        handlePagination(1, PAGE_SIZE, searchParam, sortBy, sortOrder);
      }, 800);

      return () => clearTimeout(delayDebounceFn);
    } else {
      if (props?.location?.state?.flag === 0) {
        filterHandler(draft_check, 'approvalStatus');
      } else {
        handlePagination(1, PAGE_SIZE, '', sortBy, sortOrder);
      }
    }
  }, [searchTerm, isDraftsOpen]);

  const deleteHandler = (id) => {
    setLoader(true);
    setSearchTerm('');
    Api.deleteGuidance(id).then((response) => {
      if (response?.data?.meta?.code === 1) {
        handlePagination(1, PAGE_SIZE, '', sortBy, sortOrder);
        successToast(response?.data?.meta?.message);
      } else if (response?.data?.meta?.code === 0) {
        setLoader(false);
        errorToast(response?.data?.meta?.message);
      } else {
        setLoader(false);
      }
    });
  };
  const refreshTable = () => handlePagination(1, PAGE_SIZE, '', sortBy, sortOrder);
  const handleSortBy = (sortByValue) => {
    setSortBy(sortByValue);
    if (sortByValue === sortBy) {
      let tempSortOrder = sortOrder === 1 ? -1 : 1;
      setSortOrder(tempSortOrder);
      handlePagination(currentPage, PAGE_SIZE, searchTerm, sortByValue, tempSortOrder);
    } else {
      setSortOrder(1);
      handlePagination(currentPage, PAGE_SIZE, searchTerm, sortByValue, 1);
    }
  };
  useOutsideClick(wrapperRef, () => {
    if (showFilterModal) setShowFilterModal(!showFilterModal);
  });

  const filterHandler = (data, key) => {
    setFilterCriteria((prevData) => ({
      ...prevData,
      [key]: data
    }));
    let clone = JSON.parse(JSON.stringify(filterCriteria));
    const newData = { ...clone, [key]: data };
    let tempFilterQuery = [];
    Object.keys(newData).forEach(function (key) {
      if (newData[key]?.value?.toString()) {
        tempFilterQuery.push(`&${key}=${newData[key]?.value}`);
      }
    });
    let query = tempFilterQuery?.toString()?.replaceAll(',', '');
    setFilterQuery(query);
    handlePagination(1, selectedPerPage.value, searchTerm, query, sortBy, sortOrder);
  };

  const resetHandler = () => {
    setFilterCriteria({
      accountType: '',
      affirmationStatus: ''
    });
    setFilterQuery('');
    setShowFilterModal(false);
    handlePagination(1, selectedPerPage.value, searchTerm, '', sortBy, sortOrder);
  };

  const handlePerPage = (perPage) => {
    setSelectedPerPage(perPage);
    handlePagination(1, perPage.value, searchTerm, filterQuery, sortBy, sortOrder);
  };

  useOutsideClick(wrapperRef, () => {
    if (showFilterModal) setShowFilterModal(!showFilterModal);
  });

  const handleFilterAdminList = () => {
    Api.adminList().then((response) => {
      let adminList = response?.data?.data?.map((admin) => {
        return {
          value: admin.id,
          name: admin.name
        };
      });
      adminList = [pageData.adminList, ...adminList];
      setAdminNameList(adminList);
    });
  };
  const columns = [
    {
      title: pageData.tableHeaderText.name,
      key: 'thumbnail_image_url',
      sortable: true,
      type: 'profile-without-name',
      align: 'left'
    },
    {
      title: pageData.tableHeaderText.duration,
      key: 'duration',
      sortable: false,
      type: 'text',
      align: 'center'
    },
    // {
    //   title: pageData.tableHeaderText.approvalStatus,
    //   key: 'approvalStatus',
    //   sortable: false,
    //   type: 'contentStatus',
    //   align: 'left'
    // },
    {
      title: pageData.tableHeaderText.expertName,
      key: 'expertName',
      sortable: true,
      type: 'text',
      align: 'left'
    },
    // {
    //   title: pageData.tableHeaderText.createdBy,
    //   key1: 'createdBy',
    //   key2: 'name',
    //   sortable: false,
    //   type: 'text',
    //   align: 'left',
    //   nested: true
    // },
    // {
    //   title: pageData.tableHeaderText.approvedBy,
    //   key1: 'approvedBy',
    //   key2: 'name',
    //   sortable: false,
    //   type: 'text',
    //   align: 'left',
    //   nested: true
    // },
    {
      title: pageData.tableHeaderText.createdOn,
      key: 'createdOn',
      sortable: false,
      type: 'date',
      align: 'left'
    },
    {
      title: pageData.tableHeaderText.approvedOn,
      key: 'approvedOn',
      sortable: false,
      type: 'date',
      align: 'left'
    },
    {
      title: pageData.tableHeaderText.playedMinutes,
      key: 'timeSpent',
      type: 'text',
      sortable: true,
      align: 'center'
    },
    {
      title: pageData.tableHeaderText.mostPlayed,
      key: 'timeCounts',
      type: 'text',
      sortable: true,
      align: 'center'
    },
    {
      title: pageData.tableHeaderText.status,
      key: 'healthVideoStatus',
      sortable: false,
      type: 'badge',
      align: 'left'
    },
    {
      title: '',
      key: 'action',
      type: isDraftsOpen ? 'draftAction' : 'action',
      align: 'right',
      isView: '/guidance/view',
      isEdit: '/guidance/add-edit',
      isDelete: true
    }
  ];

  return (
    <div className="relative lg:mb-[45px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageData.metaTitle}</title>
      </Helmet>
      {loader ? <Loader /> : null}
      <Topbar title={pageData.pageTitle} />
      <Breadcrumb pageList={pages} className="lg:mt-8" />
      <div className="lg:mt-4">
        <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 h-auto gap-4 lg:mt-5">
          {cardList.map((item, index) => (
            <Fragment key={index}>{item}</Fragment>
          ))}
        </div>
        <div className="sm:flex justify-between items-center mt-4 gap-y-2">
          <div className="flex h-full sm:mb-0 mb-2">
            <div className="hidden sm:flex mr-3 self-center">
              <span className="self-center md:block hidden text-sm mr-2 text-shoorah-lightBlack dark:text-white">
                {pageData.perPageText}
              </span>
              <div className="w-[80px]">
                <SelectMenu
                  menuList={PER_PAGE}
                  showLabel={false}
                  defaultSelected={selectedPerPage}
                  setSelectedMenu={handlePerPage}
                />
              </div>
            </div>
            <div className="self-center">
              <SearchInput
                id="searchKey"
                name="searchKey"
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder={pageData.searchPlaceholder}
              />
            </div>
          </div>
          <div className="flex justify-around items-start">
            <div className="sm:hidden flex self-center">
              <span className="self-center hidden text-sm mr-2 dark:text-white">
                {pageData.perPageText}
              </span>
              <div className="w-16">
                <SelectMenu
                  menuList={PER_PAGE}
                  showLabel={false}
                  defaultSelected={selectedPerPage}
                  setSelectedMenu={handlePerPage}
                />
              </div>
            </div>
            <div className="flex flex-wrap gap-y-2">
              {/* {isSuperAdmin() ? ( */}
              <div className="self-center">
                <button
                  onClick={() => {
                    setIsDraftsOpen(!isDraftsOpen);
                  }}
                  type="button"
                  className="btn-primary sm:w-auto"
                >
                  {isDraftsOpen ? pageData.listBtnText : pageData.draftBtnText}
                </button>
              </div>
              {/* ) : null} */}

              <div className="ml-3 self-center">
                <button
                  onClick={() => navigate('/guidance/add-edit')}
                  type="button"
                  className="btn-primary sm:w-auto"
                >
                  {pageData.addNewBtnText}
                </button>
              </div>
              <div className="ml-3 self-center">
                <button
                  className="btn-primary sm:w-auto"
                  onClick={() => setShowFilterModal((state) => !state)}
                >
                  <FunnelIcon className="text-white w-[18px] h-[20px] inline" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <FilterPanel
          open={showFilterModal}
          onClose={() => setShowFilterModal(false)}
          onReset={resetHandler}
        >
              <div>
                <SelectMenu
                  menuList={STATUS_FOR_DROPDOWN}
                  defaultSelected={filterCriteria.healthVideoStatus}
                  label={pageData.filtersModal.statusLabel}
                  isRequired={false}
                  setSelectedMenu={(data) => filterHandler(data, 'healthVideoStatus')}
                />
              </div>
              <div>
                <SelectMenu
                  menuList={APPROVAL_STATUS_DROPDOWN}
                  defaultSelected={filterCriteria.approvalStatus}
                  label={pageData.filtersModal.approvalStatusLabel}
                  isRequired={false}
                  setSelectedMenu={(data) => filterHandler(data, 'approvalStatus')}
                />
              </div>
              {!isSuperAdmin() && (
                <div>
                  <SelectMenu
                    menuList={adminNameList}
                    defaultSelected={filterCriteria.createdBy}
                    label={pageData.filtersModal.createdByLabel}
                    isRequired={false}
                    setSelectedMenu={(data) => filterHandler(data, 'createdBy')}
                  />
                </div>
              )}
              <div>
                <SelectMenu
                  menuList={adminNameList}
                  defaultSelected={filterCriteria.approvedBy}
                  label={pageData.filtersModal.approvedByLabel}
                  isRequired={false}
                  setSelectedMenu={(data) => filterHandler(data, 'approvedBy')}
                />
              </div>
              <div>
                <SelectMenu
                  menuList={categoriesList}
                  defaultSelected={filterCriteria.categoryId}
                  label={pageData.filtersModal.selectCategoryLabel}
                  isRequired={false}
                  setSelectedMenu={(data) => filterHandler(data, 'categoryId')}
                />
              </div>
              {/* <div>
                <SelectMenu
                  menuList={RATING_DROPDOWN}
                  defaultSelected={filterCriteria.ratings}
                  label="Ratings"
                  isRequired={false}
                  setSelectedMenu={(data) => filterHandler(data, 'ratings')}
                />
              </div> */}
            </FilterPanel>

        
        <TableCard
          pagination={{
            currentPage: currentPage,
            totalCount: totalCount,
            pageSize: selectedPerPage?.value,
            onPageChange: (page) =>
              handlePagination(
                page,
                selectedPerPage?.value,
                searchTerm,
                filterQuery,
                sortBy,
                sortOrder
              ),
            onPageSizeChange: (size) =>
              handlePerPage(PER_PAGE.find((o) => o.value === size) || PER_PAGE[0]),
            pageSizeOptions: PER_PAGE.map((o) => o.value)
          }}
        >
          <Table
            columns={columns}
            data={guidanceList}
            name={'guidance_table'}
            setDeleteId={deleteHandler}
            bottomBorder={totalCount > PAGE_SIZE}
            setSortBy={(sort) => handleSortBy(sort)}
            contentType={3}
            addNewURL="/guidance/add-edit"
            refreshTable={refreshTable}
            loader={loader}
            setSearchTerm={(data) => setSearchTerm(data)}
          />
        </TableCard>
      </div>
      
    </div>
  );
};

Guidance.propTypes = {
  location: PropTypes.any
};

export default Guidance;
